import { ElFontIconPackParams, ElIconPackParams } from './icon-pack';

export interface ElIconOptions {
  [name: string]: any;
}

export interface ElIcon {
  getClasses(options?: ElIconOptions): string[];
  getContent(options?: ElIconOptions): string;
}

export class ElFontIcon implements ElIcon {

  constructor(protected name, protected content: any, protected params: ElFontIconPackParams = {}) {}

  getClasses(options?: ElIconOptions): string[] {
    const classes = [];

    if (this.params.packClass) {
      classes.push(this.params.packClass);
    }

    const name = this.params.iconClassPrefix ? `${this.params.iconClassPrefix}-${this.name}` : this.name;
    classes.push(name);
    return classes;
  }

  getContent(options?: ElIconOptions): string {
    return this.content;
  }
}

export class ElSvgIcon implements ElIcon {

  constructor(protected name, protected content: any, protected params: ElIconPackParams = {}) {}

  getClasses(options?: ElIconOptions): string[] {
    const classes = [];

    if (this.params.packClass) {
      classes.push(this.params.packClass);
    }
    return classes;
  }

  getContent(options?: ElIconOptions): string {
    return this.content;
  }
}
